import { render, staticRenderFns } from "./app-aside.vue?vue&type=template&id=f8fdecd4&"
import script from "./app-aside.vue?vue&type=script&lang=js&"
export * from "./app-aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports